<template>
  <div style="overflow-x: hidden">
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("footer.fot6") }}
    </h1>
    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">{{ $t("footer.fot6") }}</h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <!-- <li>
                    <i class="fa fa-angle-double-right"></i>
                    <a hrefs="/downloads/all.html"
                      >{{$t('common.download')}}</a
                    >
                  </li> -->

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("footer.fot6") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <link rel="stylesheet" href="/css/download-3.css" />

    <main id="digood-inside-page">
      <section class="pagination-section">
        <div class="container">
          <div class="list-description content-style pt-4 p-3 border">
            <h3 class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              {{ $t("footer.fot6") }}
            </h3>
            <div class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp"></div>
          </div>
        </div>
      </section>
      <div class="section-margin-1x"></div>
      <section class="product-list overflow">
        <div class="container">
          <div class="row">
            <div v-for="(item, index) in list" :key="index" class="col-lg-12 col-sm-12 col-xs-12 wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <div class="thumbnail product-thumbnail">
                <div class="clearfix">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <a :href="item.url" :title="item.name" class="product-thumbnail-link">
                      <img :alt="item.name" :src="item.cover" width="100%" height="300" />
                    </a>
                  </div>
                  <div class="col-md-9 col-sm-6 col-xs-12">
                    <h3>
                      <a class="title" :href="item.url" :title="item.name" target="_blank">{{ item.name }} </a>
                    </h3>
                    <div class="download-text"></div>
                    <div class="button-box row">
                      <a class="btn btn-primary col" :href="item.url" target="_blank"><i class="fa fa-download"></i> {{ $t("common.download") }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <nav v-if="total > page.per_page" aria-label="Page navigation" style="text-align: right; margin-top: 30px">
                  <ul class="pagination">
                    <li :class="{ disabled: page.page === 1 }" key="a">
                      <a href="javascript:;" aria-label="Previous" @click="page.page !== 1 && page.page--">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li v-for="(item, i) in Math.ceil(total / page.per_page)" :key="i" :class="{ active: page.page === item }">
                      <a href="javascript:;" @click="page.page = item">{{ item }}</a>
                    </li>
                    <li :class="{ disabled: page.page === Math.ceil(total / page.per_page) }" key="b">
                      <a href="javascript:;" aria-label="Next" @click="page.page !== Math.ceil(total / page.per_page) && page.page++">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>

          </div>
        </div>
      </section>
      <div class="section-margin-1x section-margin-1x2">
        <div class="container">
          <hr />
        </div>
      </div>

      <!-- <section class="recommend-section">
        <div class="container">
          <div class="section-head wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
            <h2>{{ $t("common.recommendProducts") }}</h2>
          </div>
        </div>
        <div class="container">
          <div id="RecommendProducts" class="owl-carousel owl-theme recommend-carousel">
            <div v-for="(item, index) in info.shopList.slice(0, 5)" @click.stop="toDetail(item)" class="thumbnail">
              <a class="recommend-link">
                <img :src="item.imgList[0]" width="100%" height="600" />
              </a>
              <h3>
                <a class="title">{{ item.productName }}</a>
              </h3>
              <div class="thumbnail-desc" v-html="item.description"></div>
              <div class="button-box row">
                <a data-fancybox data-src="#QuickInquiryModal" href="javascript:;" class="btn btn-secondary col">{{ $t("products.itemBtn1") }}</a>
                <a class="btn btn-primary col">{{ $t("products.itemBtn2") }}</a>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <div class="section-margin-2x"></div>
    </main>
  </div>
</template>

<script setup>
import { onMounted, watch, ref } from "vue"
import { pageIndependentDownload } from "@/utils/api"
import i18n from "@/i18n"
import router from "@/router/index"
import { reactive } from "vue"
import axios from "axios"

const list = ref([])
const total = ref(0)
const page = reactive({ page: 1, per_page: 5 })
const getList = () => {
  // axios({
  //   url: `/api/downloads-${i18n.locale}.json`,
  //   method: "get"
  // })
  pageIndependentDownload({ page, language: i18n.locale , state:1})
  .then((res) => {
    list.value = res.data.list
    total.value = res.data.total
    console.log('-------total.value',total.value)
    setTimeout(() => {
      $(function () {
        if ($("#RecommendProducts").length) {
          $("#RecommendProducts").owlCarousel({
            margin: 10,
            items: 1,
            loop: true,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            rtl: document.querySelector("html").getAttribute("dir") === "rtl",
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            lazyLoad: true,
            responsive: {
              480: {
                items: 1
              },
              768: {
                items: 2
              },
              1024: {
                items: 4
              }
            }
          })
        }
      })
    }, 300)
  })
}

const getShopList = () => {
  axios({
    url: ``,
    method: "get"
  }).then((res) => {
    info.shopList = res.data
    upFn()
  })
}

let info = reactive({
  type: "1",
  key: "",
  page: 1,
  num: 2,
  list: [],
  shopList: []
})

// getShopList()
watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    // getShopList
    getList()
  }
)

watch([page],()=>{
  getList()
})

let upFn = () => {
  let num = 2
  let page = 1
  info.list = JSON.parse(JSON.stringify(info.shopList))
  info.list.forEach((item, index) => {
    if (index < num) {
    } else {
      num += 2
      page++
    }
    item.page = page
  })
}
upFn()
getList()

let toDetail = (item) => {
  router.push({
    path: "/ProductDetail",

    query: {
      id: item.id
    }
  })
}
</script>

<style scoped>
#digood-inside-page {
  padding-top: 70px;
}

main .content-style {
  overflow: hidden;
}

main .section-head h2 {
  font-size: 25px;
  margin-top: 0;
  margin-bottom: 1.2em;
}

main .list-description h3 {
  border-left: 3px solid var(--main-theme-color);
}

main .section-head h2:after {
  background-color: var(--main-theme-color);
}

main .thumbnail h3 {
  height: auto;
  margin-bottom: 0;
}

/*main .product-list .thumbnail a.title{height:44px;padding-bottom:0;font-size:18px;line-height:22px;overflow:hidden;display:-webkit-box !important;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2;}
    main .product-thumbnail .download-text {font-size:16px;margin:0.8em 0;line-height:20px;height:60px;overflow:hidden;display:-webkit-box !important;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:3;}*/
main .thumbnail .button-box.row .btn {
  padding: 0.5em 1.5em;
  width: auto;
}

main .product-list .thumbnail a {
  padding-bottom: 86%;
}

main .product-list .thumbnail a.title {
  padding-bottom: 0;
  font-size: 20px;
  line-height: 26px;
}

main .product-thumbnail .download-text {
  font-size: 16px;
  margin: 0.8em 0;
  line-height: 22px;
}

main .recommend-section .thumbnail a.recommend-link {
  padding-bottom: 100%;
  overflow: hidden;
}

main .product-thumbnail a.product-thumbnail-link img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}

main .recommend-section .thumbnail h3 {
  height: auto;
}

main .recommend-section .thumbnail a.title {
  padding-bottom: 0;
  line-height: 22px;
  height: 44px;
  font-size: 18px;
  overflow: hidden;
  display: -webkit-box !important;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

main .recommend-section .thumbnail .thumbnail-desc {
  overflow: hidden;
  display: -webkit-box !important;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 20px;
  height: 60px;
  margin-bottom: 15px;
}

@media only screen and (max-width: 991px) {
  #digood-inside-page {
    padding-top: 60px;
  }

  main .section-margin-1x2 {
    margin: 10px;
  }
}

@media only screen and (max-width: 767px) {
  #digood-inside-page {
    padding-top: 50px;
  }

  main .section-margin-2x {
    margin: 30px;
  }

  main .section-head h2 {
    font-size: 21px;
  }
}
</style>
